<template>
    <div class="vrm-filter_options__min-max">
        {{
            i18n
                ? $t(i18n, {
                      i18nFallback: label,
                  })
                : label
        }}
        <div class="vrm-filter_options__min-max__options">
            <label class="vrm-filter_options__min-max__label" :class="measure">
                {{
                    $t('installationoverview.min', {
                        i18nFallback: 'Min',
                    })
                }}
                <vrm-dropdown-combo
                    v-model="min"
                    :options="options"
                    :placeholder="placeholder"
                    @submit="submit"
                />
            </label>
            <div class="vrm-filter_options__min-max__divider">-</div>
            <label class="vrm-filter_options__min-max__label" :class="measure">
                {{
                    $t('installationoverview.max', {
                        i18nFallback: 'Max',
                    })
                }}
                <vrm-dropdown-combo
                    v-model="max"
                    :options="options"
                    :placeholder="placeholder"
                    @submit="submit"
                />
            </label>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmDropdownCombo from '@/vue/components/shared/VrmDropdownCombo.vue';

@Component({
    components: { VrmDropdownCombo },
    emits: ['update-min', 'update-max'],
})
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('tags')
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('core')
export default class VrmInstallationOverviewFilterMinMaxCombo extends Vue {
    @Prop({ type: Array, default: [] })
    options;
    @Model('input')
    modelMin;
    @Model('input')
    modelMax;
    @Prop({ type: String, default: '', required: false })
    label;
    @Prop({ type: String, default: '', required: false })
    measure;
    @Prop({ type: String, default: '0', required: false })
    placeholder;
    @Prop({ type: String, default: undefined, required: false })
    i18n;
    @Prop({ type: String, default: 'number' })
    inputType;
    get min() {
        return this.modelMin;
    }

    set min(newValue) {
        this.$emit('update-min', newValue);
    }

    get max() {
        return this.modelMax;
    }

    set max(newValue) {
        this.$emit('update-max', newValue);
    }

    submit() {
        this.$emit('submit', null);
    }
}
</script>
